import { ModuleModel } from '../../module.model.interface';
import { CaseDescriptor, CaseState } from '../../case/model/case';
import { ProfileModel } from '../../profile/model/profile.model';

export class CaseHistoryDescriptor implements ModuleModel {
  public discriminator = 'CaseHistoryDescriptor';

  public id: string;
  public caseId: string;
  public caseState: CaseState;
  public body: string;
  public isPublic: boolean;
  public createdBy?: string;
  public createdOn?: Date;

  public href: string;
  public modified: Date;
  public deleted: Date;

  public profileDetail: ProfileModel;
  public profileFullName: string;
  public caseDetail: CaseDescriptor;
  public organizationTitle: string;
  public formTitle: string;
  public class: string = '';

  constructor(options?: {
    id: string;
    caseId: string;
    caseState: CaseState;
    body: string;
    isPublic: boolean;
    createdBy: string;
    createdOn: Date;

    href: string;
    modified: Date;
    deleted: Date;
  }) {

    if (options) {
      this.id = options.id;
      this.caseId = options.caseId;
      this.caseState = options.caseState;
      this.body = options.body;
      this.isPublic = options.isPublic;
      this.createdBy = options.createdBy;
      this.createdOn = options.createdOn;
      this.modified = options.modified;
      this.deleted = options.deleted;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/case.history/model/case.history.ts